import PropTypes from 'prop-types';
import classNames from 'classnames';
import './Skeleton.scss';

const Skeleton = ({ className = null }) => {
  const classes = classNames('skeleton', className);
  return <div className={classes} />;
};

Skeleton.propTypes = {
  className: PropTypes.string
};

export const SkeletonSlider = () => <Skeleton className="skeleton__slider" />;
export const SkeletonBookNow = () => (
  <Skeleton className="skeleton__book-now" />
);
export const SkeletonListingDetails = () => (
  <Skeleton className="skeleton__listing-details" />
);

export default Skeleton;
